export const LanguageService = {
    translations: {
        en: {
            home: "HOME",
            fanpage: "FANPAGE",
            discord: "DISCORD",
            group: "COMMUNITY",
            links: {
                fanpage: "https://www.facebook.com/womglobaly",
                discord: "https://discord.gg/uHAzGnqdwU",
                group: "https://www.facebook.com/groups/worldofmuglobal",
                code: "https://www.facebook.com/womglobaly",
                android: "https://play.google.com/store/apps/details?id=com.womonline.chaosl",
                apk: "https://mu.world/apk/WOM.apk",
                ios: "https://mu.world/ios/",
                pc: "https://mu.world/apk/MUWorld_Setup.exe",
            },
            message: "iOS download link will be updated on 04/01/2025",
            closeButton: "Close"
        },
        vi: {
            home: "TRANG CHỦ",
            fanpage: "FANPAGE",
            discord: "DISCORD",
            group: "HỘI NHÓM",
            links: {
                fanpage: "https://www.facebook.com/worldofmuVN",
                discord: "https://discord.gg/uHAzGnqdwU",
                group: "https://www.facebook.com/groups/worldofmu2025",
                code: "https://www.facebook.com/worldofmuVN",
                android: "https://mu.world/apk/WOM.apk",
                apk: "https://mu.world/apk/WOM.apk",
                ios: "https://mu.world/ios/",
                pc: "https://mu.world/apk/MUWorld_Setup.exe",
            },
            message: "Link tải iOS sẽ được cập nhật vào ngày 01/04/2025",
            closeButton: "Đóng"
        },
    },

    detectLanguage() {
        const browserLang = navigator.language.split('-')[0];
        return browserLang === 'vi' ? 'vi' : 'en';
    },

    getTranslations() {
        return this.translations[this.detectLanguage()];
    },

    getLinks() {
        return this.translations[this.detectLanguage()].links;
    }
};